module.exports = __webpack_public_path__ + "img/84.e37eed0.svg";